import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import usePaginator from "../../../theme/Component/usePaginator";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { _DashBoardAccountCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idDashBoard: number;
}

export const DashBoardAccountCatalog = ({ idDashBoard }: Props) => {

    const dash = useDataBean(_DashBoardAccountCatalog);
    const [form, setForm] = useState<any>({
        Account: null
    })
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [idDashBoard, paginador.page])

    const getLista = () => {

        dash.instance.getDashBoardAccountCatalog(idDashBoard, form.Account, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                    //console.log(resp)
                }
            }
        )

    }



    const head = [
        { title: 'ID', property: 'IDDashBoardAccount', visible: true },
        { title: 'Usuario', property: 'AccountName', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },

    ]

    const listaBotones = () => {
        const botones = [


            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const deleteDashBoardAccount = () => {
        dash.instance.deleteDashBoardAccount(dash.bean.IDDashBoardAccount).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    return (
        <div className="row">
            <div className="col-md-6">
                <AccountEditor idAccount={form.Account} onChange={(e: any) => { setForm({ ...form, "Account": e.IDAccount }) }} label="Usuario" />
            </div>
            <div className="col-md-6 mt-4 p-2">
                <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                    Consultar
                </BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={dash.setBean} listButtons={listaBotones()} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteDashBoardAccount}>
                    <strong>Eliminar item {dash.bean.AccountName}</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}